import { render, staticRenderFns } from "./MercadoPago.vue?vue&type=template&id=1b3b7c05&scoped=true"
import script from "./MercadoPago.vue?vue&type=script&lang=js"
export * from "./MercadoPago.vue?vue&type=script&lang=js"
import style0 from "./MercadoPago.vue?vue&type=style&index=0&id=1b3b7c05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3b7c05",
  null
  
)

export default component.exports